export default "__VITE_ASSET__0270b0ea__"